import * as React from 'react';

const SvgStockFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m8 9.111 7 3.111 7-3.11V4.997L15 2 8 4.998v4.113ZM14 19.778v-6.334L6.5 10 2 11.889v7l7 3.11 5-2.221ZM22 10.778v5.545l-6 2.667V13.4l6-2.622Z", fill: "currentColor" })));

export { SvgStockFill as default };
